import React from 'react';
import { Outlet } from 'react-router-dom';
import './styles.css';
import './responsive.css';

// Páginas
import Inicio from './pages/Inicio';
import NuestraEsencia from './pages/NuestraEsencia';
import SolucionesIndustria from './pages/SolucionesIndustria';
import Maquinaria from './pages/Maquinaria';
import Certificaciones from './pages/Certificaciones';
import HistoriasExito from './pages/HistoriasExito';
import Contacto from './pages/Contacto';
import ScrollToTop from './functions/ScrollToTop';

// Componentes
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Whatsapp from './components/Whatsapp';

function MainLayout() {
  return (
    <>
    <div className="App d-flex flex-column min-vh-100">
      <Navbar />
      <ScrollToTop />
      <main className="flex-grow-1">
        <Outlet />
      </main>
      <Footer />
      <Whatsapp />
    </div>
    </>
  )
}

export default MainLayout